export default {
	nbTotalInterventions: 'Nombre total de missions',
	nbTotalAlertes: 'Nombre d’alertes détectées',
	lastIntervention: 'Dernière mission',
	nextIntervention: 'Prochaine mission',
	followedVehicule: 'Qualité de suivi du véhicule',
	pendingAlerts: 'Alertes à traiter',
}
